import { secondsToTimeString } from './_utils';

export default function TimeInterval(props: { seconds: number, mark?: boolean }) {
    const time = secondsToTimeString(Math.abs(props.seconds));
    return (<>{props.seconds < 0 ? (<>&minus;</>) : null}{time}{!props.mark ? null : (props.seconds < 0 ? ' ahead' : ' behind')}</>);
}